import { type ActualizeCartError, ACTUALIZE_CART_ERROR } from '../model'

export const ACTUALIZE_CART_ERROR_I18N_KEYS: Record<ActualizeCartError, string> = {
  [ACTUALIZE_CART_ERROR.generic]: 'shop_cart_actualize_error',
  [ACTUALIZE_CART_ERROR.unauthorized]: 'shop_cart_unauthorized',
  [ACTUALIZE_CART_ERROR.forbidden]: 'shop_cart_forbidden',
  [ACTUALIZE_CART_ERROR.productNotFound]: 'shop_cart_product_not_found',
  [ACTUALIZE_CART_ERROR.invalidProductId]: 'shop_cart_invalid_product_id',
}

const FATAL_ACTUALIZE_CART_ERRORS: ActualizeCartError[] = [
  ACTUALIZE_CART_ERROR.unauthorized,
  ACTUALIZE_CART_ERROR.forbidden,
  ACTUALIZE_CART_ERROR.generic,
]

export const isFatalActualizeCartError = (error: ActualizeCartError): boolean =>
  FATAL_ACTUALIZE_CART_ERRORS.includes(error)
